import { DebtGroupsPage } from './DebtGroupsPage';

export function ReceivablesListPage() {
  return <DebtGroupsPage side="receivables" />;
}
